module.exports = __webpack_public_path__ + "img/img_digthread_blockend.a0340a66.png";